var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "apply" },
    [
      _c("van-nav-bar", {
        attrs: {
          title: "提料申请",
          "left-arrow": "",
          "safe-area-inset-top": "",
          border: false
        },
        on: { "click-left": _vm.leftClick }
      }),
      _vm._m(0),
      _c("div", { staticClass: "orderInfo" }, [
        _c("div", { staticClass: "top" }),
        _c("div", { staticClass: "orderbg" }, [
          _c("div", { staticClass: "oddNumbers flex" }, [
            _c("div", { staticClass: "odd flexleft" }, [_vm._v("提料单号:")]),
            _c("div", { staticClass: "number" }, [
              _vm._v(_vm._s(_vm.orderInfo.openNo))
            ])
          ]),
          _c("div", { staticClass: "oddTime flex" }, [
            _c("div", { staticClass: "odd flexleft" }, [_vm._v("提交时间:")]),
            _c("div", { staticClass: "Time flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.createdTime))
            ])
          ]),
          _c("div", { staticClass: "buyOrder flex" }, [
            _c("div", { staticClass: "buy flexleft" }, [_vm._v("买料单数:")]),
            _c("div", { staticClass: "number flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.count))
            ])
          ]),
          _c("div", { staticClass: "type flex" }, [
            _c("div", { staticClass: "orderType flexleft" }, [_vm._v("种类:")]),
            _c("div", { staticClass: "category flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.goods))
            ])
          ]),
          _c("div", { staticClass: "totalWeight flex" }, [
            _c("div", { staticClass: "weight flexleft" }, [_vm._v("总重:")]),
            _c("div", { staticClass: "number flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.weight) + "克")
            ])
          ]),
          _c("div", { staticClass: "totalMoney flex" }, [
            _c("div", { staticClass: "money flexleft" }, [_vm._v("总金额:")]),
            _c("div", { staticClass: "number flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.money) + "元")
            ])
          ]),
          _c("div", { staticClass: "zhanghu flexleft" }, [
            _vm._v("中鑫金收款账户")
          ]),
          _c("div", { staticClass: "BankOfDeposit flex" }, [
            _c("div", { staticClass: "bank flexleft" }, [_vm._v("开户行:")]),
            _c("div", { staticClass: "bankName flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.bankInfo.bank))
            ])
          ]),
          _c("div", { staticClass: "collectionRen flex" }, [
            _c("div", { staticClass: "collection flexleft" }, [
              _vm._v("收款人:")
            ]),
            _c("div", { staticClass: "collectionRen flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.bankInfo.name))
            ])
          ]),
          _c("div", { staticClass: "accountNumber  flex" }, [
            _c("div", { staticClass: "account  flexleft" }, [_vm._v("账号:")]),
            _c("div", { staticClass: "number flexRight" }, [
              _vm._v(_vm._s(_vm.orderInfo.bankInfo.num))
            ])
          ])
        ]),
        _c("div", { staticClass: "know", on: { click: _vm.iKnow } }, [
          _vm._v(" 我知道了 ")
        ])
      ]),
      _c("div", { staticClass: "goSeeSee" }, [
        _vm._v(" 对应的结算单已经生成，可提交付款凭证截图，"),
        _c("i", { on: { click: _vm.goSeeSee } })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "TipsBg" }, [
      _c("div", { staticClass: "tipsTxt" }, [
        _c("div", { staticClass: "txtBg" }),
        _c("div", { staticClass: "txt" }, [
          _c("h1", [_vm._v("提料申请提交成功！")]),
          _c("p", [_vm._v("申请已进入审核(审核时间为10:00-17:00)，")]),
          _c("p", [
            _vm._v("提交付款凭证截图可加快审核喔！ "),
            _c("strong", { staticClass: "comfig" }, [_vm._v("去提交")]),
            _vm._v(" "),
            _c("span", { staticClass: "icon" })
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }